import React, { useState, useEffect, useRef } from 'react';
import '../../../../assests/css/customer/SectionHero.css';
import hero4Img from '../../../../assests/images/hero4.jpeg';
import hero5Img from '../../../../assests/images/hero5.jpeg';
import hero6Img from '../../../../assests/images/hero6.jpeg';
const SectionHero = () => {
  const [isPaused, setIsPaused] = useState(false);
  const canvasRef = useRef(null);
  const cardData = [
    {
      image: hero4Img,
      label: '1. Your Pic'
    },
    {
      image: hero5Img,
      label: '2. Dress Pic'
    },
    {
      image: hero6Img,
      label: '3. Final Look'
    }
  ];

  const rotatingWords = ['Style', 'Fashion', 'Elegance', 'Confidence', 'Beauty'];
  const [currentWord, setCurrentWord] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWord((prev) => (prev + 1) % rotatingWords.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);



  // Wavy background animation using canvas
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d');
    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);
    
    let time = 0;
    
    let frameCount = 0;
    const animate = () => {
      frameCount++;
      if (frameCount % 2 !== 0) {           // ~30fps ki jagah, half work
        requestAnimationFrame(animate);
        return;
      }
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      // Create flowing wavy lines
      for (let i = 0; i < 5; i++) {
        ctx.beginPath();
        ctx.strokeStyle = `rgba(206, 171, 147, ${0.15 - i * 0.02})`;
        ctx.lineWidth = 3;
        
        for (let x = 0; x < canvas.width; x += 6) {   // step 3 → 6, half points
          const y = Math.sin((x * 0.005) + (time * 0.02) + (i * 0.8)) * 50 + 
                    Math.sin((x * 0.01) + (time * 0.03) + (i * 1.2)) * 30 +
                    (canvas.height / 2) + (i * 60);
          
          if (x === 0) {
            ctx.moveTo(x, y);
          } else {
            ctx.lineTo(x, y);
          }
        }
        ctx.stroke();
      }
      
      time += 1;
      requestAnimationFrame(animate);
    };
    
    animate();
    return () => window.removeEventListener('resize', resizeCanvas);
  }, []);

  return (
    <div className="hero-hero-container">
  {/* Wavy Background Canvas */}
  <canvas ref={canvasRef} className="hero-wave-canvas" />

  {/* Animated Flame Effect Background */}
  <div className="hero-flame-effect"></div>
  <div className="hero-flame-effect hero-flame-2"></div>
  <div className="hero-flame-effect hero-flame-3"></div>
  
  <div className="hero-hero-content">
    {/* Left Text Section */}
    <div className="hero-left-text">
      <h1 className="hero-hero-title">
        Fashion Forward
      </h1>
      <h2 className="hero-hero-subtitle">
        <span className="hero-subtitle-text">Future-Proof Your</span>{' '}
        <span className="hero-rotating-word" key={currentWord}>
          {rotatingWords[currentWord]}
        </span>
      </h2>
      
      {/* Static Text */}
      <div className="hero-main-text-container">
        <div className="hero-main-sentence">
          Upload a photo. Pick a fit. See the magic.
        </div>
      </div>

      {/* Styled Description with Scroll Velocity Effect */}
      <div className="hero-styled-description">
        <p className="hero-description-content">
          Our AI Virtual Fitting Room eliminates the guesswork 
          and brings the dressing room on your screen.
        </p>
      </div>
    </div>

    {/* Right Cards Section - Sequential Circular Motion */}
    <div className="hero-right-cards">
      <div className={`hero-orbit-container ${isPaused ? 'hero-paused' : ''}`}>
        {cardData.map((card, index) => (
          <div 
            key={index} 
            className="hero-card-orbit"
            style={{
              animationDelay: `${index * -4}s`
            }}
          >
            <div 
              className="hero-card-3d"
              onMouseEnter={() => setIsPaused(true)}
              onMouseLeave={() => setIsPaused(false)}
            >
              {/* Electric Border - Active */}
              <div className="hero-card-border hero-electric-border"></div>
              
              <div className="hero-card-inner">
                <img src={card.image} alt={card.label} />
              </div>
              
              {/* Full width label - active */}
              <div className="hero-card-label-full">{card.label}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
</div>
  );
};

export default SectionHero;